// Used for remote server deploy
const REMOTE_Endpoints = {
    "project": "https://api.makotap.com/project/",
    "client": "https://api.makotap.com/client/",
    "issue": "https://api.makotap.com/issue/",
    "lookups": "https://api.makotap.com/lookups/",
    "upload": "https://api.makotap.com/upload/excel/",
    "cxprojectraw": "https://api.makotap.com/cxprojects/raw/",
    "cxequipment": "https://api.makotap.com/cxequipment/",
    "cxchecklistmetadata": "https://api.makotap.com/checklist-metadata/",
    "cxequipmentbyproject": "https://api.makotap.com/cxequipment/project/",
    "systemsbyproject": "https://api.makotap.com/systems/project/",
    "ingestionlog": "https://api.makotap.com/ingestion-logs/",
    "ingestionloglookup": "https://api.makotap.com/ingestion-log-lookup",
    "projectslookup": "https://api.makotap.com/cxprojects/lookup",
    "checklistbyproject": "https://api.makotap.com/checklist-metadata/project/",
    "workbookexport": "https://api.makotap.com/projects/"
};

const LOCAL_Endpoints = {
    "project": "http://localhost:8081/project/",
    "client": "http://localhost:8081/client/",
    "issue": "http://localhost:8081/issue/",
    "lookups": "http://localhost:8081/lookups/",
    "upload": "http://localhost:8081/upload/excel/",
    "cxprojectraw": "http://localhost:8081/cxprojects/raw/",
    "cxequipment": "http://localhost:8081/cxequipment/",
    "cxchecklistmetadata": "http://localhost:8081/checklist-metadata/",
    "cxequipmentbyproject": "http://localhost:8081/cxequipment/project/",
    "systemsbyproject": "http://localhost:8081/systems/project/",
    "ingestionlog": "http://localhost:8081/ingestion-logs/",
    "ingestionloglookup": "http://localhost:8081/ingestion-log-lookup",
    "projectslookup": "http://localhost:8081/cxprojects/lookup",
    "checklistbyproject": "http://localhost:8081/checklist-metadata/project/",
    "workbookexport": "http://localhost:8081/projects/"
};

const configurations = {
    local: LOCAL_Endpoints,
    azure: REMOTE_Endpoints,
};

const windowEnv = window.RUNTIME_ENV?.APP_CONFIG;
const environment = windowEnv ? windowEnv : "local";
// const environment = window.RUNTIME_ENV?.APP_CONFIG;

// Fail explicitly instead of silently choosing the wrong environment.
if (!Object.prototype.hasOwnProperty.call(configurations, environment)) {
    throw new Error(
        `Invalid REACT_APP_CONFIG: "${environment}". Expected "local" or "azure".`
    );
}

const endpoints = configurations[environment];

export default endpoints;

